import type { TripDetail, TripFormState } from '../../types';
import type { TripRequest } from '../../types';

/**
 * Builds a PATCH body with only summary fields that differ from the loaded trip.
 */
export function buildSummaryRequest(
  trip: TripDetail,
  form: TripFormState
): Partial<TripRequest> {
  const patch: Partial<TripRequest> = {};
  const trimmedTitle = form.name.trim();
  const trimmedDescription = form.description.trim();

  if (trimmedTitle !== trip.name) {
    patch.name = trimmedTitle;
  }

  const tripDescription = trip.description ?? '';
  if (trimmedDescription !== tripDescription) {
    patch.description = trimmedDescription || undefined;
  }

  if (form.visibility !== trip.visibility) {
    patch.visibility = form.visibility;
  }

  return patch;
}
